import { render, staticRenderFns } from "./c_home_comb.vue?vue&type=template&id=47f843dc&scoped=true&"
import script from "./c_home_comb.vue?vue&type=script&lang=js&"
export * from "./c_home_comb.vue?vue&type=script&lang=js&"
import style0 from "./c_home_comb.vue?vue&type=style&index=0&id=47f843dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f843dc",
  null
  
)

export default component.exports